import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CentralRiesgoIntegracionService } from '../../_services/central-riesgo-integracion.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CentralRiesgoIntegracion } from '../../_models/central-riesgo-integracion';
import { CentralRiesgoIntegracionXDia } from '../../_models/central-riesgo-integracion-x-dia';
import { CentralRiesgoIntegracionXDiaService } from '../../_services/central-riesgo-integracion-x-dia.service';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { EstadoService } from '../../_services/estado.service';
import { Estado } from '../../_models/estado';
import { NavService } from '../../_services/_nav.service';
import { Integraciones } from '../../_enums/enum';
import { sleep } from '../../utils/utilidades';
import {DominiosCorreosService} from '../../_services/dominios-correos.service';

@Component( {
  selector: 'app-central-riesgo-integracion-editar',
  templateUrl: 'central-riesgo-integracion-editar.component.html'
} )

export class CentralRiesgoIntegracionEditarComponent implements OnInit {
  columnas: any[];
  formulario: FormGroup;
  centralRiesgoIntegracion: CentralRiesgoIntegracion;
  centralRiesgoIntegracionXDia: CentralRiesgoIntegracionXDia;
  lisCentralRiesgoIntegracionXDia: CentralRiesgoIntegracionXDia[] = [];
  lisCentralRiesgoIntegracion: CentralRiesgoIntegracion[] = [];
  lisIntegracionesTodos: ListaItem[] = [];
  lisEstadosTodos: Estado[] = [];
  lisIntegraciones: SelectItem[] = [];
  lisEstados: SelectItem[] = [];
  carInformacionInicial = false;
  submitted = false;
  exisIntegracion = false;
  necesitaDiaVigencia = false;
  necesitaRangoVigencia = false;
  necesitaCorreo = false;
  rangoDias: CentralRiesgoIntegracionXDia[] = [];
  guardando = false;
  carTabla = true;
  ocuTabla = false;

  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serCentralRiesgoIntegraciones: CentralRiesgoIntegracionService,
    private serCentralRiesgoIntegracionesXDia: CentralRiesgoIntegracionXDiaService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private nav: NavService,
    private router: Router,
    private navServicio: NavService,
    private serEstados: EstadoService,
    private dominios : DominiosCorreosService,
  ) {
  }

  ngOnInit() {
    this.carInformacionInicial = true;
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.serCentralRiesgoIntegraciones.obtener( params[ 'id' ] ).subscribe( cenRieInt => {
          this.centralRiesgoIntegracion = cenRieInt;
          this.exisIntegracion = true;
          this.serCentralRiesgoIntegracionesXDia.obtenerPorCentralRiesgoIntegracion( cenRieInt.idCentralRiesgoIntegracion ).subscribe( cenRieIntXDia => {
            this.lisCentralRiesgoIntegracionXDia = cenRieIntXDia;
            if ( !this.centralRiesgoIntegracion.indicadorDiasVigencia ) {
              this.rangoDias = this.lisCentralRiesgoIntegracionXDia.filter( x => x.indicadorHabilitado );
              this.necesitaRangoVigencia = this.rangoDias.length > 0;
              this.rangoDias.sort( function( a, b ) {
                return a.dia - b.dia;
              } );
            } else {
              this.necesitaDiaVigencia = true;
            }
            this.cargarInformacionInicial();
          } );
        } );
      } else {
        this.cargarInformacionInicial();
      }
    } );

  }

  cargarInformacionInicial() {
    this.columnas = [
      { field: 'dia', header: this.navServicio.buscarMensaje( 'CENTRALRIESGO.LBL_DIA' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idCentralRiesgoIntegracion: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.idCentralRiesgoIntegracion : null ],
      idIntegracion: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.idIntegracion : null, [ Validators.required ] ],
      idEstado: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.idEstado : null ],
      diasVigencia: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.diasVigencia : null ],
      correo: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.correo : null, [ Validators.maxLength( 128 ), Validators.pattern( '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$' ) ] ],
      indicadorEncendido: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.indicadorEncendido : false, [ Validators.required ] ],
      indicadorEncendidoAliado: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.indicadorEncendidoAliado : false, [ Validators.required ] ],
      indicadorEncendidoPersonas: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.indicadorEncendidoPersonas : false, [ Validators.required ] ],
      indicadorConsultaXSolicitud: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.indicadorConsultaXSolicitud : false, [ Validators.required ] ],
      indicadorHabilitado: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.indicadorHabilitado : false, [ Validators.required ] ],
      indicadorDiasVigencia: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.indicadorDiasVigencia : false, [ Validators.required ] ],
      indicadorValidarPerfilRiesgo: [ this.centralRiesgoIntegracion ? this.centralRiesgoIntegracion.indicadorValidarPerfilRiesgo : false, [ Validators.required ] ],
      rangoVigencia: [ null ],
      indicadorRango: [ this.necesitaRangoVigencia ]
    } );

    forkJoin(
      this.lisServicio.getMasterDetails( 'ListasIntegraciones' ),
      this.serEstados.listado(),
      this.serCentralRiesgoIntegraciones.listado()
    ).subscribe( ( [ integraciones, estados, centralesRiesgo ] ) => {
      this.lisCentralRiesgoIntegracion = centralesRiesgo;

      this.lisIntegracionesTodos = integraciones;
      integraciones.map( ( s: ListaItem ) => {
        const hayIntegracion = this.lisCentralRiesgoIntegracion.find( x => x.idIntegracion == s.idLista );
        if ( !hayIntegracion ) {
          this.lisIntegraciones.push( { label: s.nombre, value: s.idLista } );
        }
      } );
      this.lisEstados.push( { label: this.navServicio.buscarMensaje( 'LBL_SELECCIONE' ), value: null } );
      estados.map( ( s: Estado ) => {
        this.lisEstados.push( { label: s.nombre, value: s.idEstado } );
      } );
      if ( this.exisIntegracion ) {
        this.formulario.controls.indicadorDiasVigencia.setValue( this.necesitaDiaVigencia );
        this.verificarIntegracion();
      }

      this.carTabla = false;
      this.carInformacionInicial = false;
    } );


  }

  get f() {
    return this.formulario.controls;
  }

  async inhabilitarDias() {
    const registros = [];
    this.lisCentralRiesgoIntegracionXDia.forEach( e => {
      if ( e.indicadorHabilitado ) {
        e.indicadorHabilitado = false;
        registros.push( e );
      }
    } );
    if ( registros.length > 0 ) {
      await this.serCentralRiesgoIntegracionesXDia.bulk( registros ).toPromise();
    }
    return;
  }

  async verificarCrearDias( idCentralRiesgoIntegracion: string ) {
    const listado: any[] = [];
    this.rangoDias.forEach( s => {
      const existe = this.lisCentralRiesgoIntegracionXDia.find( x => x.dia === s.dia );
      if ( existe && !existe.indicadorHabilitado ) {
        existe.indicadorHabilitado = true;
        listado.push( existe );
      } else if ( !existe ) {
        const objeto = {} as CentralRiesgoIntegracionXDia;
        objeto.idCentralRiesgoIntegracion = idCentralRiesgoIntegracion;
        objeto.dia = s.dia;
        objeto.indicadorHabilitado = true;
        listado.push( objeto );
      }
    } );

    this.lisCentralRiesgoIntegracionXDia.forEach( e => {
      if ( e.indicadorHabilitado && !this.rangoDias.find( y => y.dia === e.dia ) ) {
        e.indicadorHabilitado = false;
        listado.push( e );
      }
    } );

    if ( listado.length > 0 ) {
      await this.serCentralRiesgoIntegracionesXDia.bulk( listado ).toPromise();
    }
    return;
  }

  onSubmit() {

    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const formulario = this.formulario.getRawValue();

      if ( formulario.idCentralRiesgoIntegracion ) {
        if ( this.f.indicadorDiasVigencia.value ) {
          formulario.indicadorDiasVigencia = this.necesitaDiaVigencia;
          this.serCentralRiesgoIntegraciones.actualizar( formulario ).subscribe( async cenRieInt => {
            await this.inhabilitarDias();
            this.guardando = false;
            this.router.navigate( [ 'apl/central-riesgo-integracion/' ] );
          } );
        } else if ( this.f.indicadorRango.value ) {
          if ( this.rangoDias.length > 0 ) {
            formulario.indicadorHabilitado = true;
            formulario.indicadorDiasVigencia = this.necesitaDiaVigencia;
            this.serCentralRiesgoIntegraciones.actualizar( formulario ).subscribe( async cenRieInt => {
              await this.verificarCrearDias( formulario.idCentralRiesgoIntegracion );
              this.guardando = false;
              this.router.navigate( [ 'apl/central-riesgo-integracion/' ] );
            } );
          } else {
            this.nav.setMesage( 0, {
              severity: 'error', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.nav.buscarMensaje( 'CENTRALRIESGO.LBL_ERRORRANGO' )
            } );
            this.guardando = false;
          }
        } else {
          formulario.indicadorHabilitado = true;
          this.serCentralRiesgoIntegraciones.actualizar( formulario ).subscribe( async cenRieInt => {
            this.inhabilitarDias();
            this.guardando = false;
            this.router.navigate( [ 'apl/central-riesgo-integracion/' ] );
          } );
        }
      } else {
        if ( this.f.indicadorDiasVigencia.value ) {
          formulario.indicadorHabilitado = true;
          formulario.indicadorDiasVigencia = this.necesitaDiaVigencia;
          this.serCentralRiesgoIntegraciones.agregar( formulario ).subscribe( cenRieInt => {
            this.guardando = false;
            this.router.navigate( [ 'apl/central-riesgo-integracion/' ] );
          } );
        } else if ( this.f.indicadorRango.value ) {
          if ( this.rangoDias.length > 0 ) {
            formulario.indicadorHabilitado = true;
            formulario.indicadorDiasVigencia = this.necesitaDiaVigencia;
            this.serCentralRiesgoIntegraciones.agregar( formulario ).subscribe( async cenRieInt => {
              formulario.idCentralRiesgoIntegracion = cenRieInt.idCentralRiesgoIntegracion;
              await this.verificarCrearDias( formulario.idCentralRiesgoIntegracion );
              this.guardando = false;
              this.router.navigate( [ 'apl/central-riesgo-integracion/' ] );
            } );
          } else {
            this.nav.setMesage( 0, {
              severity: 'error', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.nav.buscarMensaje( 'CENTRALRIESGO.LBL_ERRORRANGO' )
            } );
            this.guardando = false;
          }
        } else {
          formulario.indicadorHabilitado = true;
          this.serCentralRiesgoIntegraciones.agregar( formulario ).subscribe( cenRieInt => {
            this.guardando = false;
            this.router.navigate( [ 'apl/central-riesgo-integracion/' ] );
          } );
        }
      }
    }

  }

  verificarIntegracion() {

    const integracion = this.lisIntegracionesTodos.find( x => x.idLista == this.formulario.controls.idIntegracion.value );
    if ( integracion.codigo === 'SAROBTPER' || integracion.codigo === Integraciones.LISTARESTRICTIVA ) {
      this.necesitaCorreo = true;
    } else if ( integracion.codigo === 'TERCONINT' ) {
      this.necesitaCorreo = false;
      this.f.correo.setValue( null );
    } else {
      this.f.correo.setValue( null );
      this.necesitaCorreo = false;
    }
    this.cambiarValidadores();
  }

  cambiarDiaVigencia() {
    this.necesitaDiaVigencia = this.f.indicadorDiasVigencia.value;
    if ( this.necesitaDiaVigencia ) {
      this.reiniciarTabla();
      this.f.indicadorRango.setValue( false );
      this.f.rangoVigencia.setValue( null );
      this.necesitaRangoVigencia = false;
    } else {
      this.f.indicadorDiasVigencia.setValue( false );
      this.necesitaDiaVigencia = false;
    }
    this.cambiarValidadores();
  }

  async reiniciarTabla() {
    this.ocuTabla = true;
    await sleep( 30 );
    this.rangoDias = [];
    this.ocuTabla = false;
  }

  cambiarRangoVigencia() {
    this.necesitaRangoVigencia = this.f.indicadorRango.value;
    if ( this.necesitaRangoVigencia ) {
      this.f.indicadorDiasVigencia.setValue( false );
      this.f.diasVigencia.setValue( null );
      this.necesitaDiaVigencia = false;
    } else {
      this.f.indicadorRango.setValue( false );
      this.necesitaRangoVigencia = false;
    }
    this.cambiarValidadores();
  }

  cambiarValidadores() {
    this.f.correo.setValidators( this.necesitaCorreo ? [ Validators.required, Validators.maxLength( 128 ), Validators.pattern( '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$' ) ] : [] );
    this.f.diasVigencia.setValidators( this.necesitaDiaVigencia ? [ Validators.required ] : [] );
    this.f.indicadorDiasVigencia.setValidators( this.necesitaDiaVigencia ? [ Validators.required ] : [] );
    this.f.diasVigencia.updateValueAndValidity();
  }

  agregarRango() {
    this.carTabla = true;
    let dia = Number( this.f.rangoVigencia.value );
    if ( dia > 0 && dia < 31 && dia !== null ) {
      if ( !this.rangoDias.find( x => x.dia == dia ) ) {
        this.carTabla = true;
        const obj = {} as CentralRiesgoIntegracionXDia;
        obj.dia = dia;
        obj.indicadorHabilitado = true;
        obj.idCentralRiesgoIntegracionXDia = null;
        this.rangoDias = [ ...this.rangoDias, obj ];
        this.rangoDias.sort( function( a, b ) {
          return a.dia - b.dia;
        } );
        this.f.rangoVigencia.setValue( null );
        this.carTabla = false;
      } else {
        this.nav.setMesage( 0, {
          severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.nav.buscarMensaje( 'CENTRALRIESGO.LBL_ERRORDIA' )
        } );
      }
    } else {
      this.nav.setMesage( 0, {
        severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.nav.buscarMensaje( 'CENTRALRIESGO.LBL_INFODIA' )
      } );
    }
    this.carTabla = false;
  }

  async eliminarDiaRango( row: any ) {
    this.carTabla = true;
    this.carInformacionInicial = true;
    await sleep( 10 );
    const indice = this.rangoDias.findIndex( x => x.dia === row.dia );
    if ( indice >= 0 ) {
      this.rangoDias.splice( indice, 1 );
    }
    this.carTabla = false;
    this.carInformacionInicial = false;

  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate( [ 'apl/central-riesgo-integracion/' ] );
        },
        reject: () => {
        }
      } );
    } else {
      this.router.navigate( [ 'apl/central-riesgo-integracion/' ] );
    }
  }
}
